/* eslint-disable max-len */
G.featureUnlock = { // The rest of the settings are at other-match3-engine\js\Config\featureUnlockDefault.js
  useNoGates: true,
  extraCoinsPerMove: {
    enabled: true,
  },
  useWebGLRenderer: true,
  shoutoutAudio: true, // Shoutouts have audio?
  requestMoveHelp: true,
  gameTriggeredMessages: { // Activates game-triggered bot messages
    botMessages: true,
  },
  transactionTracking: {
    track: { // Activates "high-value" transaction event tracking
      ss: false, // player inventory snapshots
      rm: true, // real-money transactions
      inv: false, // inventory transactions
      crmInv: false, // CRM inventory transactions, should always be false for now
    },
    purge: { // Determines whether the game should transaction histories
      ss: true,
      rm: false,
      inv: true,
      crmInv: false, // should always be false for now
    },
  },
  eventPostcard: {
    enabled: false,
    range: {
      start: 1588320000000, // May 1, 2020, 08:00:00 UTC
      end: 1588838400000, // May 7th, 2020, 08:00:00 UTC
    },
  },
  friendshipChest: { // Friendship chest
    enabled: true,
    storyMode: true, // Have normal friendship chest or story mode
  },
  fortuneCookie: {
    enabled: true,
  },
  achievementGifts: false,
  freePrizeWheelSpin: true,
  freeFailFlowWheelSpin: false,
  multipleExtraMovesFailFlow: true,

  // limit the number of times a wheel can be spun. Settings are in json/settings(IAP).js
  limitSpins: {
    prizeWheel: false,
    lossAversionWheel: false,
  },

  // Add real money wheels to game
  realMoneyPrizeWheel: true,
  realMoneyHelperWheel: true,
  realMoneyTargetedOfferWheel: true,

  unlockLevels: {
    coinDouble: 40,
  },
  reskin: { // Optional. Set this in game repo. Allows the build script to reskin the game and adding the asset
    easter: false,
    cincodemayo: false,
  },
  weeklyTournament: { // weekly tournament settings
    enabled: true,
  },
  dailyChallenge: { // daily challenge settings
    enabled: true,
  },
  brag2: { enabled: false }, // brag 2.0 flow
  gateAlgorithm: 'conservative', // Algorithm for gate unlocking
  tokenEvent: {
    enabled: false,
  },
  treasureHunt: { // Treasure Hunt super, now active on certain days!
    enabled: true,
  },
  milestoneTracking: true,
  villains: true, // Setting this to false disables super hard levels, window villain speech bubbles, tutorials and corruption
  delayedBoardAppereance: true, // Set this to enable delayed board appereance for hard levels.
  multiplePreLevelBoosters: true, // Set this to allow for multiple pre level boosters on hard and super hard levels.
  additionalInterstitialRules: {
    initial: true, // Toggles addition interstitial display rules. This is the initial implementaton. Includes EveryN, Out of Moves, Win 2 in a row, Give up
    tournamentWin: {
      enabled: true,
    },
    giftAds: {
      enabled: true,
    },
  },
  weekendShopDeal: {
    enabled: true,
  },
  annuityPacks: {
    enabled: true,
  },
};
